import { isEmptyOrZeroRow } from './parseBlocks';

export const getSprintGroups = (values: string[][]): string[][][] => {
    const groups: string[][][] = [];
    let currentGroup: string[][] = [];

    for (let i = 1; i < values.length; i++) {
        const row = values[i];

        if (isEmptyOrZeroRow(row)) {
            if (currentGroup.length) {
                groups.push(currentGroup);
                currentGroup = [];
            }
            continue;
        }

        currentGroup.push(row);
    }

    // push last group
    if (currentGroup.length) {
        groups.push(currentGroup);
    }

    return groups;
};
